/* eslint-disable react/prop-types */
import React from 'react'
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ChevronUp, ArrowLeft } from "react-feather";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from '../../core/redux/action';

const Container = (props) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const navigate = useNavigate();

  const handleBack = () => {
    if (props.onBack) {
      props.onBack();
    } else {
      navigate(-1);
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        {props.StockChecking &&
          <div className="stock-marquee">
            <div className="stock-marquee-content">
              <span className="warning-item">
                ⚠️ Stock Checking is currently in progress. {props.StockCheckingtxt}
              </span>

              <span className="warning-item">
                ⚠️ Stock Checking is currently in progress. {props.StockCheckingtxt}
              </span>
            </div>
          </div>
        }


        {/* Sticky Header */}
        <div className="page-header" style={{ position: "sticky", top: 0, zIndex: 10, backgroundColor: "#4a5a7a", padding: "8px 10px", display: "flex", alignItems: "center", }}>
          <div className="page-title d-flex align-items-center">
            {props?.showBackButton && (
              <button onClick={handleBack} style={{ border: "none", background: "#F8F9FA", color: "#01699F", width: 28, height: 28, borderRadius: 5, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", marginRight: '5px' }}>
                <ArrowLeft size={18} />
              </button>
            )}
            {/* subTitle (optional): small line under the page name, e.g. summary badges */}
            <div>
              <h5 style={{ color: "#fff", margin: 0 }}> {props.pageName || "Page Name is Missing"} </h5>
              {props.subTitle && <div style={{ marginTop: 4 }}>{props.subTitle}</div>}
            </div>
          </div>
          {/* <ul className="table-top-head d-none">
            <li>
              <OverlayTrigger placement="top" overlay={<Tooltip>Collapse</Tooltip>}>
                <Link id="collapse-header" className={data ? "active" : ""} onClick={(e) => { e.preventDefault(); dispatch(setToogleHeader(!data)) }}>
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul> */}
          <div className="page-btn">{props.headerExtra}</div>
        </div>
        {/* Scrollable area */}
        {/* <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', }}>
          {props.children}
        </div> */}
        <div style={{ minHeight: '82vh', overflowY: 'auto' }}>{props.children} </div>
      </div>
    </div>
  );
};


export default Container